/* unplugin-vue-components disabled */import { render } from "./PageContainer.vue?vue&type=template&id=56a6c46a&ts=true"
import script from "./PageContainer.vue?vue&type=script&lang=ts"
export * from "./PageContainer.vue?vue&type=script&lang=ts"

import "./PageContainer.vue?vue&type=style&index=0&id=56a6c46a&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__